import { Injectable } from '@angular/core';
import { ConfigService } from './endpoint.config.service';
import { HttpClient } from '@angular/common/http';
import { ConnectionService } from './connection.service';

@Injectable({
  providedIn: 'root'
})
export class RateService extends ConnectionService{

    currentLocationId: any;
    constructor(http: HttpClient, private configs: ConfigService) {
        super(http);

        if (this.currentLocationId == undefined && sessionStorage.getItem("company") != undefined)
            this.currentLocationId = JSON.parse(sessionStorage.getItem("company")).UserLocationId;
    }

    calculateRate(requestBody, sucFun, errFun) {
        var endPoint = this.configs.getAppApiUrl("CALCULATE_SIMPLE_RATE").replace("{{currentLocationId}}", this.currentLocationId);
      this.CallApi('post', endPoint, requestBody, null, (res) => {
            sucFun(res);
        }, (err) => {
            errFun(err);
        })
    }
}
